import React from "react";
import { useState } from "react";

import { Typography, Button, Box } from "@mui/material";

const StepElevenTransition2 = (props) => {
  //eslint-disable-next-line
  const [completed, setCompleted] = useState(true);

  return (
    <React.Fragment>
      <Typography variant="h4" sx={{ mt: "3rem", mb: "1rem", fontWeight: "bold" }}>
        You're almost there!
      </Typography>
      <Typography variant="body1">
        The 100 Club is filled with nothing but action-takers. And our job is to
        reward your actions, be it through networking opportunities or membership
        perks. <br></br>
        <br></br>So, are you ready to take your first action with us?
      </Typography>
      <Button
        color="primary"
        variant="contained"
        type="submit"
        fullWidth
        sx={{ mt: "2rem" }}
        onClick={props.handleNext}
      >
        Continue
      </Button>
      <Box sx={{ display: "flex", flexDirection: "row", pt: 2 }}>
        <Button
          color="inherit"
          disabled={props.activeStep === 0}
          onClick={props.handleBack}
          sx={{ mr: 1 }}
        >
          Back
        </Button>
        <Box sx={{ flex: "1 1 auto" }} />
      </Box>
    </React.Fragment>
  );
};

export default StepElevenTransition2;
